import type { SubscriptionTier } from '@/stores/subscription'
import { NET_BEWUST_SLUG, programsEnabled } from '@/lib/programs'

// Registry of customer services. Add new services here — they appear
// automatically in the services hub and get their own gated route.

export interface ServiceDefinition {
  id: string
  name: string
  description: string
  /** Product image shown on the hub card (path under /public). */
  image?: string
  route: string
  /** Card call-to-action; defaults to "Start de analyse". */
  cta?: string
  /** Lowest subscription tier that includes this service (undefined = free). */
  tier?: SubscriptionTier
  available: boolean
}

export const services: ServiceDefinition[] = [
  {
    id: 'battery-advice',
    name: 'Batterijadvies',
    description:
      'Ontdek wat een thuisbatterij jou oplevert, doorgerekend op je eigen energiedata: beste capaciteit, besparing per jaar en terugverdientijd.',
    image: '/Thuisbatterij.png',
    route: '/services/battery-advice',
    tier: 'premium',
    available: true,
  },
  {
    id: 'data-export',
    name: 'Energiedata-export',
    description:
      'Download de energiedata van je huishouden — afname, teruglevering en opwek — als CSV of PDF over een periode naar keuze.',
    image: '/Sparky-Perspective.png',
    route: '/services/data-export',
    cta: 'Exporteer je data',
    tier: 'standaard',
    available: true,
  },
  {
    id: 'solar-guard',
    name: 'Solar Guard',
    description:
      'Bewaak je zonnepanelen op uitval door netcongestie. Als je meedoet delen we telemetrie met netbeheerders, zodat jouw huishouden helpt netcongestie te voorkomen.',
    image: '/Zonnepanelen.png',
    route: '/services/solar-guard',
    cta: 'Beheer Solar Guard',
    tier: 'basis',
    // Temporarily disabled in the hub.
    available: false,
  },
  // The first flexibility program replaces the placeholder once programs are switched on.
  programsEnabled
    ? {
        id: 'net-bewust-thuis-laden',
        name: 'Net bewust thuis laden',
        description:
          'Laad je auto deze winter niet thuis tussen 16:00 en 21:00 en ontvang na afloop een beloning. Zo help je het stroomnet op het drukste moment van de dag.',
        image: '/Elektrische-auto.png',
        route: `/programs/${NET_BEWUST_SLUG}`,
        cta: 'Bekijk het programma',
        available: true,
      }
    : {
        id: 'grid-flexibility',
        name: 'Verdien met flexibiliteit',
        description:
          'Verdien geld door je thuisbatterij, elektrische auto of warmtepomp flexibel in te zetten voor het stroomnet. Wij regelen de handel, jij ontvangt de opbrengst.',
        image: '/Elektrische-auto.png',
        route: '#',
        tier: 'premium',
        available: false,
      },
  {
    id: 'more-soon',
    name: 'Meer diensten volgen',
    description:
      'We werken aan nieuwe analyses en rapporten voor je huishouden. Houd deze plek in de gaten.',
    route: '#',
    available: false,
  },
]

export function getService(id: string): ServiceDefinition | undefined {
  return services.find((s) => s.id === id)
}
